import { useAppSelector } from "../../redux/store/hooks"
import { selectSelectedMoodEntry } from "../../redux/ProfessionalDashboard"
import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { DateAPI } from "pokal_api"

const MOOD_LABELS = ["Sehr schlecht", "Nicht gut", "Neutral", "Gut", "Sehr gut"]
const MOOD_COLORS = ["#ef4444", "#f97316", "#eab308", "#84cc16", "#22c55e"]

function MoodDetailPanel() {
    const entry = useAppSelector(selectSelectedMoodEntry)

    if (!entry) return null

    const score = Math.min(4, Math.max(0, Math.round(entry.value)))
    const label = MOOD_LABELS[score]
    const color = MOOD_COLORS[score]
    const dateStr = DateAPI.timestampToString(new Date(entry.date).getTime(), true)

    return (
        <Card>
            <SmallHeadingComponent>Stimmung</SmallHeadingComponent>
            <div className="flex items-center gap-2 mt-2">
                <span
                    className="inline-block w-3 h-3 rounded-full flex-shrink-0"
                    style={{ backgroundColor: color }}
                />
                <span className="text-sm font-medium text-gray-800">{label}</span>
                <span className="text-xs text-gray-400 ml-1">({score} / 4)</span>
            </div>
            <p className="text-xs text-gray-500 mt-1">{dateStr}</p>
            {entry.note && (
                <div className="mt-3 rounded-md bg-gray-50 border border-gray-200 px-3 py-2">
                    <p className="text-xs text-gray-500 font-medium mb-0.5">Notiz</p>
                    <p className="text-sm text-gray-700 whitespace-pre-wrap">{entry.note}</p>
                </div>
            )}
        </Card>
    )
}

export default MoodDetailPanel
